import styled from "styled-components";
import { cssVariables } from "constants/css";

const ChatLogItem = styled.div`
  font-size: ${cssVariables.mainFontSize};
`;
export const Root = ChatLogItem;
